import { cn } from "@utils";

// Circular loader in the Ontik AI gradient (violet → fuchsia → orange — the same
// palette as the "Ontik suggests" sparkle). A conic gradient swept around the ring
// (fading in from transparent) gives a vivid comet-style sweep as it spins, rather
// than the flat look of a linear gradient across a short arc.
export default function AiSpinner({
  size = 18,
  strokeWidth = 3,
  durationMs = 800,
  className,
}) {
  const mask = `radial-gradient(farthest-side, transparent calc(100% - ${strokeWidth}px), #000 calc(100% - ${strokeWidth}px))`;

  // Reuse the app's shared rotation animation (`animate-circular-rotate`); the core
  // `animate-spin` utility isn't generated in this Tailwind build.
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn("inline-block rounded-full animate-circular-rotate", className)}
      style={{
        width: size,
        height: size,
        transformOrigin: "50% 50%",
        ["--spinner-duration"]: `${durationMs}ms`,
        background:
          "conic-gradient(from 0deg, rgba(139,92,246,0) 0%, #8b5cf6 35%, #d946ef 70%, #fb923c 100%)",
        WebkitMask: mask,
        mask,
      }}
    />
  );
}
